import React from 'react'
import { useSelector } from 'react-redux'

import views from '../../configuration/views'

import CalendarContainer from './calendar/CalendarContainer'
import DailyGridContainer from './grid/DailyGridContainer'
import WeeklyGridContainer from './grid/WeeklyGridContainer'

const Views = () => {
  const currentView = useSelector(state => state.filtersData.view)

  const renderView = () => {
    switch (currentView) {
      case views.monthly:
        return <CalendarContainer/>
      case views.daily:
        return <DailyGridContainer/>
      case views.weekly:
        return <WeeklyGridContainer/>
      default:
        return <CalendarContainer/>
    }
  }

  return renderView()
}

export default Views
